import { useFullStoryPageView } from 'hooks/useFullstoryPageView';

import { BottomHeaderSection } from 'components/common/PageContainer/BottomHeaderSection';
import { HeaderWrapper } from 'components/common/PageContainer/HeaderWrapper';
import { MainContent } from 'components/common/PageContainer/MainContent';
import PageContainer from 'components/common/PageContainer/PageContainer';
import { ProgramTopHeader } from 'components/common/ProgramTopHeader/ProgramTopHeader';

import { AddRole } from 'components/Settings/Components/RolesManagement/components/addRole';
import { settingsConfig } from 'components/Settings/settingsConfig';

const AddRolePage = () => {
    useFullStoryPageView({ pageName: settingsConfig.roleManagement.title });

    return (
        <PageContainer>
            <HeaderWrapper>
                <BottomHeaderSection>
                    <ProgramTopHeader pageTitle={settingsConfig.roleManagement.title} showBack={true} />
                </BottomHeaderSection>
            </HeaderWrapper>
            <MainContent>
                <AddRole />
            </MainContent>
        </PageContainer>
    );
};

export default AddRolePage;
